import { Book } from 'src/core/models/book.model';

export interface BooksState {
  books: Book[];
}

export const initialBooksState: BooksState = {
  books: []
}
